var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLightboxgallery = function SvgLightboxgallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.636.5h2.182c.904 0 1.637.733 1.637 1.636v2.182c0 .904-.733 1.637-1.637 1.637H1.636A1.636 1.636 0 0 1 0 4.318V2.136C0 1.233.733.5 1.636.5Zm6.546 0h2.182C11.267.5 12 1.233 12 2.136v2.182c0 .904-.733 1.637-1.636 1.637H8.182a1.636 1.636 0 0 1-1.637-1.637V2.136C6.545 1.233 7.278.5 8.182.5ZM3.818 7.045H1.636C.733 7.045 0 7.778 0 8.682v2.182c0 .903.733 1.636 1.636 1.636h2.182c.904 0 1.637-.733 1.637-1.636V8.682c0-.904-.733-1.637-1.637-1.637Zm4.364 0h2.182c.903 0 1.636.733 1.636 1.637v2.182c0 .903-.733 1.636-1.636 1.636H8.182a1.636 1.636 0 0 1-1.637-1.636V8.682c0-.904.733-1.637 1.637-1.637Z"
  })));
};

export default SvgLightboxgallery;